/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { CSVLink } from 'react-csv';
// import printJS from 'print-js';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import Header from './sub_components/main/header';
import Footer from './sub_components/main/footer';
import * as agentService from '../services/agentService';
// import * as dateUtil from '../util/date.util';
// import { BASE_IMAGE_PATH_NEW } from '../configs/api';

class AgentMaster extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         agentName: '',
         agentNameAlreadyExist: false,
         agentMobileNumber: '',
         agentRefrenceName: '',
         agentRemarks: '',
         user_id: '',
         agentsList: [],
         showData: false,
         loader: false,
         pageLimit: 25,
         pageActive: 1,
         page_no: 1, 
      };
      // records_display: 100,
      // csv_json: [],
      // pdf_json: [],
   }

   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         window.location.href = window.location.origin + "/auth"
      }
      this.getAgentsList();
   }

   
   getAgentsList() {
      const self = this;
      this.setState({
         loader: true
      },()=>{
         agentService.getAgentsList().then((res) => {
            if (!!res) {
               self.setState(
                  {
                     agentsList: [],
                     showData: true,
                     loader: true
                  }, () => {
                     this.setState({
                     agentsList: res,
                     loader: false
                     });
                  }
               );
            }
            else {
               this.setState({ agentsList: [], showData: true, loader: false });
            }
         });
      });
   }

   componentWillUnmount(){
      
   }

   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   resetForm() {
      this.setState({ 
         agentName: '',
         agentNameAlreadyExist: false,
         agentMobileNumber: '',
         agentRefrenceName: '',
         agentRemarks: '',
      });
   }

   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value, pageActive: 1 });
   }

   agentNameBlur(){
      const self = this;
      if(this.state.agentName !== '') {
         agentService.agentCheckname(this.state.agentName).then(async (result) => {
            self.setState({agentNameAlreadyExist : result ? false : true});
         })
      }
   }

   onSubmit(e) {
      const self = this;
      if(this.state.agentName === ''){
         return false;
      }

      let body = {
        Name: this.state.agentName,
        Mobile: this.state.agentMobileNumber,
        Remarks: this.state.agentRemarks,
        ReferenceName: this.state.agentRefrenceName
      }
      this.setState({loader: true}, ()=>{
         agentService.addAgent(body).then((res) => {
            if (res.isSuccess) {
               self.resetForm();
               self.getAgentsList();
            } else {
               self.props.notify(res.exception.message, "error");
               self.setState({ loading: false });
            }
        });
      })
   }
   
   onAction(e) {
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }) ) 
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }) )
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil(Object.keys(this.state.mySharingUserMappedList).length / this.state.pageLimit)}) ) 
      } 
   }

   agentIsActive(agt){
      const self = this;
      agentService.activeDeactiveAgent(agt.name, !agt.isActive).then((res) => {
         if (res.isSuccess) {
            let agentsLst = self.state.agentsList;
            for(let agtt of agentsLst){
               if(agtt.name === agt.name){
                  agtt.isActive = !agtt.isActive;
                  break;
               }
            }
            self.setState({agentsList: agentsLst});
            // self.resetForm();
            // self.getAgentsList();
         } else {
            self.props.notify(res.exception.message, "error");
            // self.setState({ loading: false });
         }
     });
   }
   
   render() {
      // const eventPnL_data = {};//this.filterEventPnLListWithGrouping()
      // const totatOrderCnt = eventPnL_data.totatOrderCount
      // const ttlPnl = eventPnL_data.totalPnl
      // const ttlStakes = eventPnL_data.totalStakes
      // let totatDisplayOrderCount = 0
      // let totalDisplayPnl = 0
      // let totalDisplayStakes = 0
      // let totatDisplayOrderCountPdf = 0
      // let totalDisplayPnlPdf = 0
      // let totalDisplayStakesPdf = 0
      const agentsList = this.state.agentsList;
      let lst = []
      let total_page = Math.ceil( agentsList.length/ this.state.pageLimit)
      for (let x = 1; x <= total_page; x++) {
         if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => {{ this.onAction(e) } this.setState({ pageActive: x })}}>{x} </button>
            lst.push(htm)
         }
      }

      return (
         <>
            <div className="bethubs">
               <Header history={this.props.history} />
               <div className="wrapper">
                  <div className="container-fluid container-padding-0">
                     <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                           <div className="main-box">
                              <h5 className="text-blue">Add Agent Details</h5>
                              <div className="row mt-2">
                                 
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <input placeholder="Add Name" name='agentName' value={this.state.agentName} onChange={(e) => this.onChange(e)} onBlur={()=> this.agentNameBlur()}/>
                                       {
                                          (this.state.agentName !== "" && this.state.agentNameAlreadyExist) &&
                                          <label id='useralreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This Agent already exist.</label>
                                       }
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <input placeholder="Add Mobile Number" name='agentMobileNumber' value={this.state.agentMobileNumber} onChange={(e) => this.onChange(e)}/>
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <input placeholder="Add Refrence Name" name='agentRefrenceName' value={this.state.agentRefrenceName} onChange={(e) => this.onChange(e)}/>
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <input placeholder="Remark" name='agentRemarks' value={this.state.agentRemarks} onChange={(e) => this.onChange(e)}/>
                                    </div>
                                 </div>
                                 
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                       <button className="btn btn-blue" disabled={this.state.agentName === '' || this.state.agentNameAlreadyExist ? true : false} onClick={(e) => this.onSubmit(e)}>Submit</button>
                                       <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                    </div>
                                 </div>
                              </div>
                              {/* {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null} */}
                               <div>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="table-responsive">
                                          <table id="example" className="table font-12 table-bordered table-sm addpadding table-striped mt-2">
                                             <thead>
                                                <tr>
                                                   <th className="pthead">Name</th>
                                                   <th className="pthead">Mobile Number</th>
                                                   <th className="pthead">Refrence Name</th>
                                                   <th className="pthead">Remarks</th>
                                                   <th className="pthead">Is Active</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {(this.state.showData && !this.state.loader) && !!agentsList  && agentsList.length>0 ? agentsList.map((agt, i) => {
                                                   return(<>{i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && 
                                                      <tr key={`agt_${i}`}>
                                                         <td>{agt.name}</td>
                                                         <td>{agt.mobile}</td>
                                                         <td>{agt.referenceName}</td>
                                                         <td>{agt.remarks}</td>
                                                         <td>
                                                            <input checked={agt.isActive} className="form-check-input ml-0" id={`isActive_${agt.name}`} onChange={()=> this.agentIsActive(agt)} type="checkbox" value="true"/>
                                                         </td>
                                                      </tr>}</>
                                                   )})
                                                   :
                                                   this.state.loader ?
                                                   <tr>
                                                      <td colSpan={5}> Loading... </td>
                                                   </tr>
                                                   :
                                                   <tr>
                                                      <td colSpan={5}> No Data Found... </td>
                                                   </tr>
                                                }
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              
                              { 
                                 agentsList.length > 0 &&
                                 <>       
                                    <div className="row">
                                       <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) <  agentsList.length ? (this.state.pageLimit * this.state.pageActive) :  agentsList.length} of { agentsList.length} entries</span></div>
                                       <div className="col-12 col-sm-12 col-md-6">
                                          <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                             <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                             <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                             {lst}  
                                             <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( agentsList.length / this.state.pageLimit)? true : false}>Next</button>
                                             <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( agentsList.length / this.state.pageLimit)? true : false}>Last</button>
                                          </div>
                                       </div>
                                    </div>
                                 </>
                              }

                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <Footer />
               {/* {this.state.onShowOrderPopup && <EventPnLReportMarketOrderModel user_id={this.state.client_id} current_user={this.state.user_id} selectedMarketList={this.state.selectedMarketList} hidePopupBets={() => { this.onHideOrderPopup() }} />} */}
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgentMaster);